import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/nieuwesportclub/";

const BezoekerApi = {
    validateOrganisatie(model) {
        const serviceUrl = prependRoot(routePrefix + '/validateOrganisatie', getApiRoot());
        return axios.put(serviceUrl, model,
            {
                headers: {
                    'accept': 'application/json'
                }
            });
    },
    validateIdentificatie(model) {
        const serviceUrl = prependRoot(routePrefix + '/validateIdentificatie', getApiRoot());
        return axios.put(serviceUrl, model,
            {
                headers: {
                    'accept': 'application/json'
                }
            });
    },
    listSporttakkenByFilter(filter) {
        const serviceUrl = prependRoot(routePrefix + "/listsporttakkenbyfilter", getApiRoot());
        return axios.put(serviceUrl, { Search: filter }, {
            headers: {
                'accept': 'application/json'
            }
        });
    },
    validateAdres(model) {
        const serviceUrl = prependRoot(routePrefix + '/validateAdres', getApiRoot());
        return axios.put(serviceUrl, model,
            {
                headers: {
                    'accept': 'application/json'
                }
            });
    },
    validateSocialeMedia(model) {
        const serviceUrl = prependRoot(routePrefix + '/validateSocialeMedia', getApiRoot());
        return axios.put(serviceUrl, model,
            {
                headers: {
                    'accept': 'application/json'
                }
            });
    },
	dienIn(model) {
		const serviceUrl = prependRoot(routePrefix + "/dienIn", getApiRoot());
		return axios.put(serviceUrl, model, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default BezoekerApi;